<template lang="pug">
  .link.row.middle
    input.input-base.input-border(
      type='text'
      :value='linkValue'
      ref='linkInput'
      :placeholder='$t("krea.kreaActions.insertLinkPlaceholder")'
    )
    button.middle.center.link-button(@click.prevent='updatedLink')
      simple-svg.black-icon(:filepath='checkIcon' width='20px' height='20px')
    button.middle.center.link-button(@click.prevent='removedLink')
      simple-svg.black-icon(:filepath='trashIcon' width='20px' height='20px')
</template>

<script>
import bulbIcon from '@/assets/krea/ic_bulb.svg'
import checkIcon from '@/assets/ic_check_base.svg'
import trashIcon from '@/assets/krea/ic_trash.svg'

export default {
  props: {
    linkValue: { type: String }
  },
  data() {
    return {
      bulbIcon,
      checkIcon,
      trashIcon
    }
  },
  methods: {
    updatedLink() {
      this.$emit('updatedLink', this.$refs.linkInput.value)
    },
    removedLink() {
      this.$emit('removedLink', '')
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.input-base{
  margin: 0;
}

.link-button{
  padding: 10px;
  border-radius: 5px;
  &:hover{
    background-color: $light-gray;
  }
}

.link{
  gap: 5px;
  background-color: $white;
  border: 1px solid $black;
  padding: 10px;
  bottom: 100%;
  width: 450px;
  border-radius: 5px;
}
</style>
